import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { HISTORY, occupancyOptions } from "../consts";
import { useGetPropertyAssociationList } from "@/services";

const useOccupantsDialog = ({ selectedRow }: {selectedRow: any}) => {
  const [activeTab, setActiveTab] = useState<string>(selectedRow?.selectedTab);
  const isHistory = useMemo(() => activeTab == HISTORY, [activeTab]);

  useEffect(() => {
    if (isHistory) refetchUserGridData();
  }, [isHistory]);

  const onTabChange = (tab: string) => {
    setActiveTab(tab);
  }

  const {
    data: usersGridData,
    isLoading: isUserGridLoading,
    refetch: refetchUserGridData,
    isRefetching: isRefetchingUserData
  } = useGetPropertyAssociationList({
    data: {
      filters: [
        {
          field: "communityId",
          value: selectedRow?.communityId,
          operator: "EQUAL",
        },
        {
          field: "propertyId",
          value: selectedRow?.propertyId,
          operator: "EQUAL",
        },

      ],
      pageSize: 10,
      pageNumber: 0
    },
    queryParams: {
      enabled: false
    }
  });
  
  const columns = [
    {
      accessorKey: "fullName",
      header: <div>Person Name</div>,
      accessorFn: (row: any) => isHistory ? `${row?.firstName} ${row?.lastName}` : String(row?.fullName || ""),
    },
    {
      accessorKey: "associationType",
      header: <div>Role</div>,
      accessorFn: (row: any) => occupancyOptions?.find((data: any) => data?.value == row?.associationType)?.label || "",
    },
    {
      accessorKey: "startDate",
      header: <div>Stay Period</div>,
      accessorFn: (row: any) => row?.startDate && row?.endDate ? `${moment(row?.startDate).format("MM/DD/YYYY")} - ${moment(row?.endDate).format("MM/DD/YYYY")}` : `${moment(row?.startDate).format("MM/DD/YYYY")} - Present`,
    },
  ]

  return {
    activeTab,
    onTabChange,
    columns,
    isLoading: isUserGridLoading || isRefetchingUserData,
    usersGridData
  }
}

export default useOccupantsDialog;